import { z } from 'zod';

/////////////////////////////////////////
// NOTIFICATIONS MASS NOTIFICATION SCHEMA
/////////////////////////////////////////

export const NotificationsMassNotificationSchema = z.object({
  id: z.bigint(),
  city_id: z.number().int().nullable(),
  content_id: z.number().int().nullable(),
  author_id: z.string().nullable(),
  message: z.string().nullable(),
  progress: z.number().int().nullable(),
  total: z.number().int().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  channels: z.string().nullable(),
  scheduled_at: z.coerce.date().nullable(),
  billingTransactionId: z.number().int().nullable(),
})

export type NotificationsMassNotification = z.infer<typeof NotificationsMassNotificationSchema>

export default NotificationsMassNotificationSchema;
